import React from 'react';
import { onSetActivePage, onSetActiveGeography } from '../../data/StatusStore';
interface SplashScreenProps {
  isOpen: boolean;
  onClose: () => void;
  setShowAbout: Function;
}

const SplashScreen: React.FC<SplashScreenProps> = ({ isOpen, onClose, setShowAbout }) => {
    if (!isOpen) return null;

    // Clicking the semi-transparent overlay closes the splash
    const handleOverlayClick = () => {
        onClose();
    };

    // Prevent closing when clicking inside the dialog
    const handleDialogClick = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
    };

    const hdiDataStory = () => {
        console.log('HDI Data Story clicked');
        onSetActiveGeography('CD');
        onSetActivePage('stories');
        onClose();
    };
    const goToAbout = () => {
        console.log('Go to About clicked');
        setShowAbout(true);
        onClose();

    };
    const getStarted = () => {
        console.log('Get Staerted');
        onClose();
    };

    return (
        <div
        className="splash-overlay"
        onClick={handleOverlayClick}
        style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgb(165 96 0 / 80%)',
            zIndex: 999999, // High enough to cover navbar
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}
        >
        <div
            className="splash-dialog"
            onClick={handleDialogClick}
            style={{
                position: 'relative',
                width: '719px',
                maxWidth: '90%',
                backgroundColor: '#fff',
                padding: '24px 30px',
                borderRadius: '25px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
                fontFamily: 'Arial, sans-serif',
                textAlign: 'left',
                lineHeight: 1.5,
                border: '2px solid black',
                height: 'calc(100% - 60px)',
                maxHeight: '550px',
                overflowY: 'auto',
                marginTop: '60px',
                marginBottom: '30px',
            }}
        >
            {/* Close Button (X) */}
            <button
            onClick={onClose}
            style={{
                position: 'absolute',
                top: '16px',
                right: '16px',
                background: 'transparent',
                border: 'none',
                fontSize: '1.5rem',
                cursor: 'pointer',
                lineHeight: '1',
            }}
            >
            &times;
            </button>

            <h1 style={{ margin: '20px 0 1rem', fontSize: '21px', fontWeight: 'bold' }}>
            WELCOME TO DATA2GO.NYC!
            </h1>

            <p style={{ margin: '0 0 1.2rem', fontSize: '18px', lineHeight:'22px' }}>
            DATA2GO.NYC is a free, easy-to-use online mapping and data tool created by the nonprofit
            Measure of America of the Social Science Research Council with funding from The Leona M.
            and Harry B. Helmsley Charitable Trust. It brings together federal, state, and city data
            on a broad range of issues critical to the well-being of all New Yorkers.
            </p>

            <p style={{ margin: '0 0 1.2rem', fontSize: '18px', lineHeight:'22px', fontWeight: 'bold', cursor: 'pointer' }} onClick={onClose}>
            Click <span style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={() => getStarted()}>here</span> to begin
            </p>
            
            <div style={{ height:'2px', width:'100%', backgroundColor:'black', margin: '1.2rem 0' }} />
            
            <p style={{ margin: '0 0 1.2rem', fontSize: '18px', lineHeight:'22px' }}>
            Check out our <span style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={() => hdiDataStory()}>HDI Data Story</span> which shows the main features of the site.
            </p>

            <p style={{ margin: '0 0 1rem', fontSize: '18px', lineHeight:'22px' }}>
            <span style={{ }}>Learn more about the project <span style={{ textDecoration: 'underline', cursor: 'pointer', color:"#000" }} onClick={() => goToAbout()}>here</span>.</span>
            </p>

            <p style={{ margin: '0 0 1rem', fontSize: '18px', lineHeight:'22px' }}>
            <span style={{ }}>Find our FAQ page <a style={{ textDecoration: 'underline', cursor: 'pointer', color:"#000" }} href="/D2G FAQ_2025-04-29.pdf" target="_blank">here</a>.</span>
            </p>

            <p style={{ margin: '0 0 1.5rem', fontSize: '18px', lineHeight:'22px' }}>
            <span style={{ }}>Learn more about Measure of America <a style={{ textDecoration: 'underline', cursor: 'pointer', color:"#000" }} href="https://measureofamerica.org/" target="_blank">here</a>.</span>
            </p>

            <p style={{ margin: '0 0 0.5rem', fontSize: '18px', lineHeight:'22px', fontWeight: 'bold' }}>
            DATA2GO in Action:
            </p>
            <p style={{ margin: 0, fontSize: '18px', lineHeight:'22px' }}>
            See how <span style={{ textDecoration: 'underline', cursor: 'pointer' }}><a style={{ textDecoration: 'underline', cursor: 'pointer', color:"#000" }} href="https://www.measureofamerica.org/NewYorkCares/" target="_blank">New York Cares</a></span>,{' '}
            <span style={{ textDecoration: 'underline', cursor: 'pointer' }}><a style={{ textDecoration: 'underline', cursor: 'pointer', color:"#000" }} href="https://measureofamerica.org/CommonPantry/" target="_blank">NY Common Pantry</a></span>,{' '}
            <span style={{ textDecoration: 'underline', cursor: 'pointer' }}><a style={{ textDecoration: 'underline', cursor: 'pointer', color:"#000" }} href="https://www.measureofamerica.org/NYCLoveYourLocal/" target="_blank">NYC Love Your Local</a></span>, and other community
            organizations have used DATA2GO.
            </p>
        </div>
        </div>
    );
};

export default SplashScreen;
